// Auto-curated index of cities that have a /locations/{slug}/web-design page.
// Used by the city hub "Services available in {City}" block and by the
// /websites page "Web design across Australia" grid. Update this list when a
// new src/data/locationServicePages/{slug}.web-design.ts file is added.

export type LocationWebDesignEntry = {
  slug: string;
  city: string;
  state: "QLD" | "NSW" | "VIC" | "SA" | "WA" | "TAS" | "NT" | "ACT";
};

export const LOCATION_WEB_DESIGN_INDEX: readonly LocationWebDesignEntry[] = [
  { slug: "adelaide", city: "Adelaide", state: "SA" },
  { slug: "albury", city: "Albury", state: "NSW" },
  { slug: "alice-springs", city: "Alice Springs", state: "NT" },
  { slug: "armidale", city: "Armidale", state: "NSW" },
  { slug: "ballarat", city: "Ballarat", state: "VIC" },
  { slug: "batemans-bay", city: "Batemans Bay", state: "NSW" },
  { slug: "bathurst", city: "Bathurst", state: "NSW" },
  { slug: "bega-valley", city: "Bega Valley", state: "NSW" },
  { slug: "bendigo", city: "Bendigo", state: "VIC" },
  { slug: "brisbane", city: "Brisbane", state: "QLD" },
  { slug: "broken-hill", city: "Broken Hill", state: "NSW" },
  { slug: "bundaberg", city: "Bundaberg", state: "QLD" },
  { slug: "burleigh-heads", city: "Burleigh Heads", state: "QLD" },
  { slug: "burnett", city: "Burnett", state: "QLD" },
  { slug: "cairns", city: "Cairns", state: "QLD" },
  { slug: "canberra", city: "Canberra", state: "ACT" },
  { slug: "cassowary-coast", city: "Cassowary Coast", state: "QLD" },
  { slug: "central-coast", city: "Central Coast", state: "NSW" },
  { slug: "coffs-harbour", city: "Coffs Harbour", state: "NSW" },
  { slug: "darwin", city: "Darwin", state: "NT" },
  { slug: "dubbo", city: "Dubbo", state: "NSW" },
  { slug: "emerald", city: "Emerald", state: "QLD" },
  { slug: "fraser-coast", city: "Fraser Coast", state: "QLD" },
  { slug: "geelong", city: "Geelong", state: "VIC" },
  { slug: "gippsland", city: "Gippsland", state: "VIC" },
  { slug: "gladstone", city: "Gladstone", state: "QLD" },
  { slug: "gold-coast", city: "Gold Coast", state: "QLD" },
  { slug: "gosford", city: "Gosford", state: "NSW" },
  { slug: "goulburn", city: "Goulburn", state: "NSW" },
  { slug: "griffith", city: "Griffith", state: "NSW" },
  { slug: "gympie", city: "Gympie", state: "QLD" },
  { slug: "hobart", city: "Hobart", state: "TAS" },
  { slug: "horsham", city: "Horsham", state: "VIC" },
  { slug: "ipswich", city: "Ipswich", state: "QLD" },
  { slug: "kimberley", city: "Kimberley", state: "WA" },
  { slug: "launceston", city: "Launceston", state: "TAS" },
  { slug: "limestone-coast", city: "Limestone Coast", state: "SA" },
  { slug: "lockyer-valley", city: "Lockyer Valley", state: "QLD" },
  { slug: "mackay", city: "Mackay", state: "QLD" },
  { slug: "maitland", city: "Maitland", state: "NSW" },
  { slug: "melbourne", city: "Melbourne", state: "VIC" },
  { slug: "mildura", city: "Mildura", state: "VIC" },
  { slug: "moreton-bay", city: "Moreton Bay", state: "QLD" },
  { slug: "mornington-peninsula", city: "Mornington Peninsula", state: "VIC" },
  { slug: "mount-isa", city: "Mount Isa", state: "QLD" },
  { slug: "newcastle", city: "Newcastle", state: "NSW" },
  { slug: "noosa-heads", city: "Noosa Heads", state: "QLD" },
  { slug: "northern-rivers", city: "Northern Rivers", state: "NSW" },
  { slug: "nowra", city: "Nowra", state: "NSW" },
  { slug: "nw-tasmania", city: "North West Tasmania", state: "TAS" },
  { slug: "orange", city: "Orange", state: "NSW" },
  { slug: "parkes", city: "Parkes", state: "NSW" },
  { slug: "perth", city: "Perth", state: "WA" },
  { slug: "port-macquarie", city: "Port Macquarie", state: "NSW" },
  { slug: "port-stephens", city: "Port Stephens", state: "NSW" },
  { slug: "rockhampton", city: "Rockhampton", state: "QLD" },
  { slug: "scenic-rim", city: "Scenic Rim", state: "QLD" },
  { slug: "se-tasmania", city: "South East Tasmania", state: "TAS" },
  { slug: "shellharbour", city: "Shellharbour", state: "NSW" },
  { slug: "shepparton", city: "Shepparton", state: "VIC" },
  { slug: "singleton", city: "Singleton", state: "NSW" },
  { slug: "snowy-mountains", city: "Snowy Mountains", state: "NSW" },
  { slug: "southern-downs", city: "Southern Downs", state: "QLD" },
  { slug: "southern-highlands", city: "Southern Highlands", state: "NSW" },
  { slug: "sunshine-coast", city: "Sunshine Coast", state: "QLD" },
  { slug: "sydney", city: "Sydney", state: "NSW" },
  { slug: "tablelands", city: "Tablelands", state: "QLD" },
  { slug: "tamworth", city: "Tamworth", state: "NSW" },
  { slug: "taree", city: "Taree", state: "NSW" },
  { slug: "toowoomba", city: "Toowoomba", state: "QLD" },
  { slug: "townsville", city: "Townsville", state: "QLD" },
  { slug: "tweed-coast", city: "Tweed Coast", state: "NSW" },
  { slug: "wagga-wagga", city: "Wagga Wagga", state: "NSW" },
  { slug: "wangaratta", city: "Wangaratta", state: "VIC" },
  { slug: "warrnambool", city: "Warrnambool", state: "VIC" },
  { slug: "warwick", city: "Warwick", state: "QLD" },
  { slug: "whitsundays", city: "Whitsundays", state: "QLD" },
  { slug: "wollongong", city: "Wollongong", state: "NSW" },
  { slug: "wyong", city: "Wyong", state: "NSW" },
  { slug: "yass", city: "Yass", state: "NSW" },
] as const;

export const hasWebDesignPage = (slug: string): boolean =>
  LOCATION_WEB_DESIGN_INDEX.some((e) => e.slug === slug);

// Deduped by city display name — for the public-facing /websites grid we want
// one tile per place, even if two slugs (e.g. cassowary + cassowary-coast)
// point at the same city.
export const LOCATION_WEB_DESIGN_UNIQUE: readonly LocationWebDesignEntry[] =
  (() => {
    const seen = new Set<string>();
    const out: LocationWebDesignEntry[] = [];
    for (const entry of LOCATION_WEB_DESIGN_INDEX) {
      if (seen.has(entry.city)) continue;
      seen.add(entry.city);
      out.push(entry);
    }
    return out;
  })();
